import { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { Box } from "@mui/material";
import Alert from "../../../layout/Alert";
import "./DACCount.css";

const DACCount = ({ dacData, getDACCount }) => {
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [showDACData, setShowDACData] = useState(false);

    const handleStartDateChange = (date) => {
        setStartDateFilter(date);
        setEndDateFilter(null);
        setShowDACData(false);
    };
    const handleEndDateChange = (date) => {
        setEndDateFilter(date);
        setShowDACData(false);
    };
    const filter = () => {
        setShowDACData(false);
        const startDate = format(new Date(Number(startDateFilter)), "dd-MM-yyyy");
        const endDate = format(new Date(Number(endDateFilter)), "dd-MM-yyyy");
        getDACCount({ startTs: startDate, endTs: endDate }, () => setShowDACData(true));
    };

    return (
        <Box sx={{ width: "100%", minWidth: 0 }}>
            <Box className="content-block bottom-shadow dac-count-filter">
                <Box className="py-15 dac-count-filter-row">
                    <div className="dac-count-filter-group">
                        <Box component="label" className="dac-count-filter-label">From:</Box>
                        <DatePicker
                            selected={startDateFilter}
                            maxDate={new Date()}
                            onChange={handleStartDateChange}
                            placeholderText="Start Date"
                            dateFormat="MM/dd/yyyy"
                            className="add-input calendar input_phone"
                        />
                    </div>
                    <div className="dac-count-filter-group dac-count-filter-group-to">
                        <Box component="label" className="dac-count-filter-label">To:</Box>
                        <DatePicker
                            selected={endDateFilter}
                            minDate={startDateFilter}
                            maxDate={new Date()}
                            onChange={handleEndDateChange}
                            placeholderText="End Date"
                            dateFormat="MM/dd/yyyy"
                            className="add-input calendar input_phone"
                        />
                    </div>
                    <div className="dac-count-filter-btn-wrap">
                        <button
                            type="button"
                            className="btn btn-style-2 orange-bg"
                            onClick={filter}
                            disabled={startDateFilter === null || endDateFilter === null}
                            style={{ minWidth: 80, height: 40 }}
                        >
                            Filter
                        </button>
                    </div>
                </Box>
            </Box>
            <Alert />
            {showDACData && (
                <Box className="content-block bottom-shadow" sx={{ mt: 1 }}>
                    <Box className="page-title" sx={{ m: 1, ml: 2 }}>
                        <Box component="h3" sx={{ m: 0 }}>{`DAC Count : ${dacData?.hasOwnProperty("count") ? dacData?.count : "-"}`}</Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default DACCount